import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'

import index from '@/pages/index.vue'
import aboutPark from '@/pages/aboutPark.vue'
import news from '@/pages/news.vue'
import newsdetail from '@/pages/newsdetail.vue'
import shopping from '@/pages/shopping.vue'
import catering from '@/pages/catering.vue'
import project from '@/pages/project.vue'
// import show from '@/pages/show.vue'
// import route from '@/pages/route.vue'
// import fareInform from '@/pages/fareInform.vue'
// import bussinessHour from '@/pages/bussinessHour.vue'
import parkMap from '@/pages/parkMap.vue'
import traffic from '@/pages/traffic.vue'
// import chargeGuide from '@/pages/chargeGuide.vue'
import aboutUs from '@/pages/aboutUs.vue'
import hotel from '@/pages/hotel.vue'
import theme from '@/pages/theme.vue'
import themeDetail from '@/pages/themeDetail.vue'
import entertainment from '@/pages/entertainment.vue'

// import question from '@/pages/question.vue'


const routes = [{
  path: '/',
  component: index,
  meta: {
    title: '',
  }
},
{
  path: '/aboutPark',
  component: aboutPark,
  meta: {
    title: '园区介绍',
  }
},
{
  path: '/theme',
  component: theme,
  meta: {
    title: '主题活动',
  }
},
{
  path: '/themeDetail',
  component: themeDetail,
  meta: {
    title: '主题活动',
  }
},
{
  path: '/news',
  component: news,
  meta: {
    title: '动态公告',
  }
},
{
  path: '/newsdetail',
  component: newsdetail,
  meta: {
    title: '动态公告',
  }
},
{
  path: '/shopping',
  component: shopping,
  meta: {
    title: '特享购物',
  }
},
{
  path: '/catering',
  component: catering,
  meta: {
    title: '特选美食',
  }
},
{
  path: '/hotel',
  component: hotel,
  meta: {
    title: '精选住宿',
  }
},
{
  path: '/entertainment',
  component: entertainment,
  meta: {
    title: '休闲娱乐',
  }
},
{
  path: '/adventurePark',
  component: project,
  meta: {
    title: '开放式主题街区',
    type: 1
  }
},
{
  path: '/waterPark',
  component: project,
  meta: {
    title: '熊出没水上乐园',
    type: 2
  }
},
// {
//   path: '/show',
//   component: show,
//   meta: {
//     title: '精彩演艺',
//   }
// },
// {
//   path: '/route',
//   component: route,
//   meta: {
//     title: '推荐路线',
//   }
// },
// {
//   path: '/fareInform',
//   component: fareInform,
//   meta: {
//     title: '票价信息',
//   }
// },
// {
//   path: '/bussinessHour',
//   component: bussinessHour,
//   meta: {
//     title: '营业时间',
//   }
// },
{
  path: '/parkMap',
  component: parkMap,
  meta: {
    title: '园区地图',
  }
},
{
  path: '/traffic',
  component: traffic,
  meta: {
    title: '交通指南',
  }
},
// {
//   path: '/chargeGuide',
//   component: chargeGuide,
//   meta: {
//     title: '收费指南',
//   }
// },
{
  path: '/aboutUs',
  component: aboutUs,
  meta: {
    title: '招商合作',
  }
},
  // {
  //   path: '/notice',
  //   component: notice,
  //   meta: {
  //     title: '游客须知',
  //   }
  // },
  // {
  //   path: '/question',
  //   component: question,
  //   meta: {
  //     title: '常见问题',
  //   }
  // }
];

export default createRouter({
  // history: createWebHashHistory(),
  history: createWebHistory("/BoonieBearsBay/"),
  scrollBehavior(to, from, savedPosition) {
    // 滚动到顶部
    return { top: 0 }
  },
  routes
});